/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";

import { useI18n } from "hooks/i18n/i18n";
import { useGetEventList } from "hooks/event/useGetEventList";

import { getEventDisplayInfo } from "utility";
import { changeStyleWithHosting } from "utility/hosting";

import { Breadcrumb } from "components/atoms/Breadcrumb";
import { MainContents } from "components/templates/MainContents";
import { EventCard } from "features/EventCard";

interface Props {}
export const ArchiveEventList: React.FC<Props> = (_props) => {
  const { data: events, isLoading } = useGetEventList({
    type: "archive",
  });

  const { t } = useI18n();
  const classesEventListDesign = eventListDesign();
  const menuPastEventsText =
    changeStyleWithHosting().commonSettings.menu.pastEvents.text;

  const displayEvents = events ? events : [];

  if (displayEvents.length === 0 && !isLoading) {
    return (
      <MainContents>
        <Breadcrumb
          // @ts-expect-error TS2322
          paths={[
            ["/", "ホーム"],
            [null, `${menuPastEventsText}`],
          ]}
        />

        <div css={classesEventListDesign.eventNothingLabel}>
          {t("event.noEvent.noArchive")}
        </div>
      </MainContents>
    );
  }

  return (
    <MainContents>
      <Breadcrumb
        // @ts-expect-error TS2322
        paths={[
          ["/", "ホーム"],
          [null, `${menuPastEventsText}`],
        ]}
      />

      <div css={classesEventListDesign.root}>
        {displayEvents.map((event) => {
          const { isOpenStreamingPage } = getEventDisplayInfo(event);

          if (isOpenStreamingPage) return null;

          return (
            <React.Fragment key={event._id}>
              <EventCard event={event} exceptionStatus={"archived"} />
            </React.Fragment>
          );
        })}
      </div>
    </MainContents>
  );
};

const eventListDesign = () => {
  return {
    root: css`
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 90%;
      max-width: 980px;
      padding: 40px 0 80px;
      margin: 0 auto;
      &::after {
        content: "";
        display: block;
        width: 31%;
        margin-bottom: 20px;
      }
      .event-card {
        width: 47.5%;
        margin-bottom: 20px;
        @media screen and (min-width: 768px) {
          width: 31%;
        }
      }
    `,

    eventNothingLabel: css`
      height: calc(100vh - (255px + 194px));
      padding: 10px;
      margin-top: 100px;
      color: #888888;
      font-size: 20px;
      text-align: center;
      @media screen and (min-width: 768px) {
        font-size: 24px;
      }
    `,
  };
};
